module.exports = __webpack_public_path__ + "static/media/3.17bd15f1.jpg";